import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/styles";
import { ScrollToTopOnMount } from "frame/components";
import AlertEmailForm from "./alert-email-form";
import FeatureFlagsForm from "./feature-flags-form";
import { isStaffUser } from "utils";
import { useRouter } from "utils";
import * as fromRoutes from "../../actions/types";

const useStyles = makeStyles((theme) => ({
	root: {
		padding: theme.spacing(0, 3, 10, 3),
		backgroundColor: theme.palette.white,
		borderRadius: theme.shape.borderRadius,
		boxShadow: theme.shadows[1],
		[theme.breakpoints.down("xs")]: {
			paddingRight: theme.spacing(0),
		},
	},
}));

const Notifications = ({
	alertEmails = [],
	notificationeEmails,
	loading,
	onFetch,
	onSaveAlertEmails,
	role,
}) => {
	const classes = useStyles();
	const { history } = useRouter();

	if (isStaffUser(role)) {
		history.push(fromRoutes.ACCOUNT_PROFILE_PATH);
	}

	// notificationeEmails && notificationeEmails.map(({ email, allowNotifications }) =>
	//   allowNotifications && !alertEmails.includes(email) && alertEmails.push(email))

	const emailsToSync = (notificationeEmails || [])
		.filter((n) => n && n.allowNotifications)
		.map((n) => n.email)
		.filter(Boolean);
	const mergedArray = Array.from(new Set([...(alertEmails || []), ...emailsToSync]));

	useEffect(() => {
		onFetch();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<div
			className={classes.root}
		>
			<ScrollToTopOnMount />

			<FeatureFlagsForm
				incidentAlertEmails={mergedArray}
				incidentAlertEmailsLoading={loading}
				onSaveIncidentAlertEmails={onSaveAlertEmails}
			/>
		</div>
	);
};

Notifications.propTypes = {
	alertEmails: PropTypes.array,
	notificationeEmails: PropTypes.array,
	loading: PropTypes.bool,
	onFetch: PropTypes.func.isRequired,
	onSaveAlertEmails: PropTypes.func.isRequired,
	role: PropTypes.string.isRequired,
};

export default Notifications;
